import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from '../util';
const Small = (_jsx("svg", Object.assign({ viewBox: "0 0 18 18" }, { children: _jsx("path", { fill: "currentColor", d: "M15.304 9.387h-1.193v7.407h-2.552v-3.998c0-.636-.51-1.152-1.14-1.152H7.562c-.63 0-1.14.516-1.14 1.152v3.998H3.87V9.387H1.43l7.616-8.1 7.527 8.1h-1.269zm-7.688 7.407h2.749V12.85h-2.75v3.944zm10.107-7.931L9.788.325A1.008 1.008 0 008.31.32L.282 8.858c-.616.655-.156 1.735.737 1.735h1.657v6.38c0 .567.456 1.027 1.018 1.027h10.593c.562 0 1.017-.46 1.017-1.027v-6.38h1.677c.89 0 1.35-1.075.742-1.73z" }, void 0) }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
